import { createGlobalStyle } from "styled-components";
import { theme } from "styled-tools";
import {
  SpoqaHanSansNeoBold,
  SpoqaHanSansNeoLight,
  SpoqaHanSansNeoMedium,
  SpoqaHanSansNeoRegular,
  SpoqaHanSansNeoThin,
} from "assets/fonts/font";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import Close from "assets/icons/close.svg";

const GlobalStyles = createGlobalStyle`


@font-face {
    font-family: 'SpoqaHanSansNeo-Thin';
    src: url(${SpoqaHanSansNeoThin}) format('woff2');
    font-weight: 100;
    font-display: swap;
}
@font-face {
    font-family: 'SpoqaHanSansNeo-Light';
    src: url(${SpoqaHanSansNeoLight}) format('woff2');
    font-weight: 300;
    font-display: swap;
}
@font-face {
    font-family: 'SpoqaHanSansNeo-Regular';
    src: url(${SpoqaHanSansNeoRegular}) format('woff2');
    font-weight: 400;
    font-display: swap;
}
@font-face {
    font-family: 'SpoqaHanSansNeo-Medium';
    src: url(${SpoqaHanSansNeoMedium}) format('woff2');
    font-weight: 500;
    font-display: swap;
}
@font-face {
    font-family: 'SpoqaHanSansNeo-Bold';
    src: url(${SpoqaHanSansNeoBold}) format('woff2');
    font-weight: 700;
    font-display: swap;
}

* {
  margin: 0;
  font-family: 'SpoqaHanSansNeo-Regular', 'Apple SD Gothic Neo', sans-serif;
  -webkit-font-smoothing: antialiased; /* macOS */
  -moz-osx-font-smoothing: grayscale;  /* Firefox/mac */
  text-rendering: optimizeLegibility;  /* Windows에서도 부드럽게 */
}
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
  html {
    font-size: 10px;
  }
  body {
    height: 100%;
  @supports (-webkit-touch-callout: none) {
    min-height: -webkit-fill-available;
  }

    /** Custom Aiqua Popup background */
    #qgraphFakePromptContainer{
      > div:first-child{
        background: rgba(0,0,0,.2) !important;
      }
    }
  }
  a, button {
    text-decoration: none;
    cursor: pointer;
    border: none;
    outline: none;
  }

  h1 {
    ${theme("fontStyle.h3")}
  }

  h2 {
    ${theme("fontStyle.h4")}
  }

  h2 {
    ${theme("fontStyle.h5")}
  }

  h3 {
    ${theme("fontStyle.subtitle1")}
  }

  h4 {
    ${theme("fontStyle.subtitle2")}
  }

  h5 {
    ${theme("fontStyle.body1")}
  }

  text{
    font-family: 'SpoqaHanSansNeo-Bold';
  }

  p {
    ${theme("fontStyle.body2")}
  }
  .hljs{
    background: #000000;
  }
  -ms-overflow-style: scrollbar;  /* IE and Edge */
  overflow-x: hidden;
  overflow-y: auto;
  /* &::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 7px;
    height: 2px;
    display: block;
  }
  &::-webkit-scrollbar-thumb {
    max-width: 230px;
    background-color: #653cd5;
    -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
  }
  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(180, 185, 171, 0.3);
    background-color: #b4b9ab;
  } */
  outline : none;

  .slick-slider {
    .slick-arrow {
      &.slick-prev{
        display: none !important;
      }
      &.slick-next{
        display: none !important;
      }
    }
  }

  .ant-input[disabled] , input[disabled] {
    background-color: #fff;
    cursor: no-drop;
  }

  .ant-btn[disabled], .ant-btn[disabled]:hover{
    border: none;
    font-family: 'SpoqaHanSansNeo-Medium';
  }
  
  /* Select */
  .ant-select-item-option-content {
    font-size: 16px;
  }

  /* CheckBox */
  .ant-checkbox-wrapper{
    .ant-checkbox-wrapper:hover .ant-checkbox-inner, .ant-checkbox:hover .ant-checkbox-inner, .ant-checkbox-input:focus + .ant-checkbox-inner{
      border: 1px solid #d9d9d9;
    }
    .ant-checkbox-checked{
      &::after{
        border: none;
      }
    }
  }

  .ant-radio-checked .ant-radio-inner {
    border-color: #0D0D0D;
    &::after {
      background: #0D0D0D;
    }
  }
  .ant-radio-wrapper {
    margin-right: 40px;
  }
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #0D0D0D;
    border-color: #0D0D0D;

    /* &:after{
      content: "\e816" ;
      font-family: 'themify-icons';
      border:none;
      transform: rotate(0deg) scale(1) translate(-20%, -20%);
    } */
  }

  /** ======================================== */

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }

  .ant-modal-wrap {
    cursor: url(${Close}), auto;
  }
  .ant-modal-content {
    cursor: default;
  }

  .hidden-mobile {
    @media screen and (max-width: 768px) {
      display: none;
    }
  }

  /* .ant-pagination {
    @media screen and (max-width: 768px) {
      text-align: center;
    }
  }; */

  .ant-pagination {
    .ant-pagination-prev, .ant-pagination-next {
      color: #999999;
    }
    .ant-pagination-item {
      border: none;
      background-color: unset;
      font-weight: 400;
      font-size: 16px;
      line-height: 100%;
      text-align: center;
      min-width: 11px;
      height: 19px;

      @media screen and (max-width: 768px) {
        font-size: 18px;
      }

      @media (max-width: 567px) {
        font-size: 18px;
      }

      a {
        color: #999999;
      }
    }
    .ant-pagination-item-active {
      border-bottom: solid 1px #653cd5 !important;
      border-radius: 0px;

      a {
        font-weight: 800;
        font-size: 16px;
        line-height: 100%;
        text-align: center;
        color: #653cd5;

        @media screen and (max-width: 768px) {
          font-size: 18px;
        }

        @media (max-width: 567px) {
          font-size: 18px;
        }
      }
    }
    .ant-pagination-item-link {
      border: none;
      background: transparent;
    }

    @media screen and (max-width: 768px) {
      justify-content: center;
      text-align: center;
      font-weight: 800;
      line-height: 100%;

      @media screen and (max-width: 768px) {
        font-size: 18px;
      }

      @media (max-width: 567px) {
        font-size: 18px;
      }
    }
  }
  /**modal */
  .ant-modal-root{
    .ant-modal {
      //width: unset !important;
    }
      @media(max-width : 360px) {
        /* margin: 0; */
        max-width: 100% !important;
        padding: 0 15px;
      }

      .ant-modal-content {
        position: relative;
        border-radius: 14px;
        
        
        .ant-modal-body {
          max-height: 80vh;
          max-height: 80dvh;
          overflow-y: auto;
          padding-bottom: 0;
          
          > div {
            position: static;
            padding: 0;
            padding-bottom: 90px;
          }
          

          .wrapper-btn {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: #fff;
            padding: 20px 24px;
          }
        }
      }
    }

    .no-scroll {
      .ant-modal-body {
        max-height: unset !important;
      }
    }
  }
  /**table */
  .ant-table-wrapper {
    .ant-table-body {
      &::-webkit-scrollbar {
        -webkit-appearance: none;
        width: 0px;
        display: block;
      }
    }
  }
  .ant-table-wrapper .ant-table-body .ant-table-tbody > tr > td {
    overflow: auto;
    &::-webkit-scrollbar {
      display: none;
    }
    &:last-child {
      border-right: none;
    }
  }

  /**select antd */
  .ant-select-item {
    .ant-select-item-option-content {
      font-size: 14px;
      font-weight: 500;
      color: #0D0D0D;
    }
  }

  .marquee {
    min-width: unset !important;
  }

  /**popup error api */
  .ant-notification {
    .ant-notification-notice {
      .ant-notification-notice-message {
        text-align: center;
        margin-top: 8px;
        text-align: center;
        font-family: "SpoqaHanSansNeo-Medium";
        font-size: 16px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: 0.6px;
        color: #0D0D0D;
        padding-right: 40px;
      }
      .ant-notification-notice-close {
        top : 24px;
        .ant-notification-close-icon {
          font-size: 13px;
          color: #111;
          border-radius: 50%;
          background-color: #d9d9d9;
          padding: 5px;
        }
      }
    }
  }

  /** daum kakao address */
  .box-modified{
    >div >span{
      background-color: #0D0D0D;
    }
  }
`;

export default GlobalStyles;
